import * as actionTypes from 'constants/ActionTypes';

const initState = {
};

const issue = (state = initState, action) => {
    switch (action.type) {
    case actionTypes.GET_ISSUE.REQUEST:
        return {
            ...state,
            ...action.data,
            isLoaded: false,
        };
    case actionTypes.GET_ISSUE.SUCCESS: {
        return {
            ...state,
            ...action.data,
            isLoaded: true,
        };
    }
    case actionTypes.GET_ISSUE.FAILURE:
        return {
            ...state,
            ...action.data,
            isLoaded: true,
        };

    case actionTypes.UPDATE_ISSUE_STATUS.REQUEST: {
        return {
            ...state,
            ...action.data,
            isLoaded: false,
        };
    }
    case actionTypes.UPDATE_ISSUE_STATUS.SUCCESS: {
        return {
            ...state,
            ...action.data,
            isLoaded: true,
        };
    }
    case actionTypes.UPDATE_ISSUE_STATUS.FAILURE:
        return {
            ...state,
            ...action.data,
            isLoaded: true,
        };

    case actionTypes.ADD_ISSUE_COMMENT.REQUEST: {
        return {
            ...state,
            isLoaded: false,
        };
    }
    case actionTypes.ADD_ISSUE_COMMENT.SUCCESS: {
        return {
            ...state,
            ...action.data,
            isLoaded: true,
        };
    }
    case actionTypes.ADD_ISSUE_COMMENT.FAILURE:
        return {
            ...state,
            ...action.data,
            isLoaded: true,
        };

    case actionTypes.UPDATE_ISSUE_COMMENT.REQUEST: {
        return {
            ...state,
            isLoaded: false,
        };
    }
    case actionTypes.UPDATE_ISSUE_COMMENT.SUCCESS: {
        return {
            ...state,
            ...action.data,
            isLoaded: true,
        };
    }
    case actionTypes.UPDATE_ISSUE_COMMENT.FAILURE:
        return {
            ...state,
            ...action.data,
            isLoaded: true,
        };

    case actionTypes.DELETE_ISSUE_COMMENT.REQUEST: {
        return {
            ...state,
            isLoaded: false,
        };
    }
    case actionTypes.DELETE_ISSUE_COMMENT.SUCCESS: {
        return {
            ...state,
            ...action.data,
            isLoaded: true,
        };
    }
    case actionTypes.DELETE_ISSUE_COMMENT.FAILURE:
        return {
            ...state,
            ...action.data,
            isLoaded: true,
        };

    default:
        return state;
    }
};

export default issue;



// WEBPACK FOOTER //
// ./app/reducers/issues/issue.js